import { Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { useCallback, useContext, useMemo } from 'react';
import { GroupSettingsContext } from '../../../contexts/GroupSettingsContext';
import theme from '../../../theme';
import { ColorOptions } from '../../../theme/colors';

const useStyles = makeStyles(() => ({
    badge: {
        padding: '4px 8px',
        height: '30px',
        borderRadius: '32px',
        width: 'auto',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        whiteSpace: 'nowrap'
    },
}));

const SingleStatusBadge: React.FC<{ title: string, callback?: () => void }> = ({ title, callback }) => {
    const classes = useStyles();
    const { statuses } = useContext(GroupSettingsContext);

    const palettes = useMemo(() => Array.from(new Set(Object.values(ColorOptions)
        .filter(color => !['neutral', 'brown', 'lime', 'pink', 'red', 'shades'].includes(color)))), []);

    const getColors = useCallback((title: string) => {
        const index = statuses.findIndex((s) => s.toLowerCase() === title.toLowerCase());

        if ((index !== -1) && (index < palettes.length)) {
            return ({
                backgroundColor: theme.colors[palettes[index]][100],
                color: theme.colors[palettes[index]][800],
            });
        }

        return ({
            backgroundColor: theme.colors.neutral[100],
            color: theme.colors.neutral[600],
        });
    }, [statuses, palettes]);

    return <Typography
        className={classes.badge}
        variant="b3-semibold"
        sx={{
            ...getColors(title),
            textTransform: 'capitalize'
        }}
        onClick={() => {
            callback?.();
        }}
    >
        {title}
    </Typography>
};

export default SingleStatusBadge;